<template>
  <div class="main-container">
    <div class="precompilation-page">
      <div class="precompilation-page__left">
        <main-menu></main-menu>
      </div>
      <div class="precompilation-page__right">
        <div class="form--overflow">
          <div class="form__row">
            <div class="btns-row__left-btns">
              <Label class="form__label">
                <p><b>Clear cache pipelines:</b></p>
                <p></p>
              </Label>
            </div>
            <div class="btns-row__left-btns">
              <p><clear-cache-btn></clear-cache-btn></p>
            </div>
            <div class="btns-row__left-btns">
              <p><run-pipeline-btn></run-pipeline-btn></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainMenu from '../MainMenu/MainMenu.vue'
import ClearCacheBtn from '../ClearCacheBtn/ClearCacheBtn.vue'
import RunPipelineBtn from '../RunPipeline/RunPipeline.vue';
export default {
  components: {MainMenu, ClearCacheBtn, RunPipelineBtn},
  name: 'ClearCachePage',
  props: [],
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss" src="./ClearCachePage.scss">

</style>
